import { render } from "./DocumentsBlock.vue?vue&type=template&id=03a631b2"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__